import { Component, OnInit } from '@angular/core';
declare var jquery:any; 
declare var $ :any;
@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css']
})
export class SidemenuComponent implements OnInit {

  constructor() { }

  ngOnInit()/* : void  */{
    
    
  
 /*  $('body').on('click', function (e) {
     console.log("xx");
  }); */
  $('.navbar-nav>li>a').on('click', function(){
    $('.navbar-collapse').collapse('hide');
});
  }


}
